/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';

/**
 * 
 * @export
 * @interface ExcludeAppointmentDayResponse
 */
export interface ExcludeAppointmentDayResponse {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof ExcludeAppointmentDayResponse
     */
    id: ApiUserTasksGetLastSelectedIdParameter;
}

/**
 * Check if a given object implements the ExcludeAppointmentDayResponse interface.
 */
export function instanceOfExcludeAppointmentDayResponse(value: object): value is ExcludeAppointmentDayResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function ExcludeAppointmentDayResponseFromJSON(json: any): ExcludeAppointmentDayResponse {
    return ExcludeAppointmentDayResponseFromJSONTyped(json, false);
}

export function ExcludeAppointmentDayResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExcludeAppointmentDayResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['id']),
    };
}

export function ExcludeAppointmentDayResponseToJSON(json: any): ExcludeAppointmentDayResponse {
    return ExcludeAppointmentDayResponseToJSONTyped(json, false);
}

export function ExcludeAppointmentDayResponseToJSONTyped(value?: ExcludeAppointmentDayResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterToJSON(value['id']),
    };
}

